export const ZipAndCityInterface = {
    /**
     * @type {string}
     */
    SelectorCheckoutAddressCountry: 'checkout_address_form_country',
    /**
     * @type {string}
     */
    SelectorCheckoutAddressZip: 'checkout_address_form_zip',
    /**
     * @type {string}
     */
    SelectorCheckoutAddressCity: 'checkout_address_form_city',
    /**
     * @type {string}
     */
    SelectorCheckoutAddressShippingZip: 'checkout_address_form_shippingZip',
    /**
     * @type {string}
     */
    SelectorCheckoutAddressShippingCity: 'checkout_address_form_shippingCity',
    /**
     * @type {string}
     */
    SelectorAddressCitySuggestionContainer: 'city-suggestion-container',
    /**
     * @type {string}
     */
    SelectorAddressZipSuggestionContainer: 'zip-suggestion-container',
    /**
     * @type {string}
     */
    SelectorShippingAddressCitySuggestionContainer: 'shipping-city-suggestion-container',
    /**
     * @type {string}
     */
    SelectorShippingAddressZipSuggestionContainer: 'shipping-zip-suggestion-container',
    /**
     * @type {string}
     */
    ParameterLocationCity: 'postalcode',
    /**
     * @type {string}
     */
    ParameterLocationPostalCode: 'city',
    /**
     * @type {string}
     */
    ParameterLocationCountry: 'country',
    /**
     * @type {string}
     */
    KeyToCitySuggestions: 'cities',
    /**
     * @type {string}
     */
    KeyToZipSuggestions: 'postalCodes',
    /**
     * @type {string}
     */
    SelectorCitySuggestionClass: 'suggestion-item',
    /**
     * @type {string}
     */
    DataAttributeCity: 'data-city',
    /**
     * @type {string}
     */
    DataAttributeZip: 'data-zip',
    /**
     * @type {string}
     */
    DefaultCountry: 'DE',
}